import React from "react";
import { Link } from "react-router-dom";

import cn from "@/utils/cn";

type Props = {
  to: string;
  name: string;
  icon?: React.ReactElement;
  isCurrent: boolean;
  count?: number;
  isCollapsed: boolean;
  onNavigate?: () => void;
};

export const SidebarNavItemLink = ({
  to,
  name,
  icon,
  isCurrent,
  count,
  isCollapsed,
  onNavigate,
}: Props) => {
  if (isCollapsed) {
    return (
      <Link
        to={to}
        onClick={onNavigate}
        className={cn(
          "group relative flex min-h-[64px] flex-col items-center justify-center gap-y-1 rounded-md px-0 py-2 text-md font-medium transition-all duration-300 hover:bg-chorus-black-200",
          isCurrent
            ? "bg-chorus-black-200 text-chorus-gray-200"
            : "text-chorus-gray-300",
        )}
        data-testid={name}
      >
        <div className="relative">
          {icon &&
            React.cloneElement(icon, {
              className: cn(
                "shrink-0 transition-all duration-300",
                isCurrent ? "fill-chorus-gray-400" : "fill-chorus-gray-600",
              ),
            })}
          {Boolean(count) && (
            <span className="absolute -right-1 -top-1 inline-flex size-2 rounded-full bg-chorus-red-600" />
          )}
        </div>
        <span className="text-center text-xxs transition-all duration-300">
          {name}
        </span>
      </Link>
    );
  }

  return (
    <Link
      to={to}
      onClick={onNavigate}
      className={cn(
        "group relative flex h-12 items-center gap-x-[10px] rounded-md px-3 py-0 text-md font-medium transition-all duration-300 hover:bg-chorus-black-200",
        isCurrent
          ? "bg-chorus-black-200 text-chorus-gray-200"
          : "text-chorus-gray-300",
      )}
      data-testid={name}
    >
      {icon &&
        React.cloneElement(icon, {
          className: cn(
            "shrink-0 transition-all duration-300",
            isCurrent ? "fill-chorus-gray-400" : "fill-chorus-gray-600",
          ),
        })}
      <span className="whitespace-nowrap opacity-100 transition-all duration-300">
        {name}
      </span>
      {Boolean(count) && (
        <span className="ml-auto inline-flex h-5 min-w-[30px] items-center justify-center rounded-[20px] bg-chorus-red-600 px-2 text-xxs font-semibold text-chorus-red-100">
          {count}
        </span>
      )}
    </Link>
  );
};
